export default function Features() {
  // Example logos (replace with your own images or SVGs)
  const logos = [
    "Win Real Money",
    "Quiz Games",
    "Earning opportunity",
    "Refer and earn"
  ];

  return (
    <div className="lg:py-12 md:py-12 py-4 bg-black">
      <h3 className="text-white text-lg lg:mb-8 md:mb-8 mb-4 text-center font-medium">
        Features
      </h3>
      <div className="overflow-x-hidden lg:w-1/2 md:w-1/2 mx-auto">
        <div className="flex lg:gap-[80px] md:gap-[80px] gap-[10px] animate-features-carousel items-center w-max">
          {[...logos, ...logos].map((logo, idx) => (
            <div className="text-[10px] lg:text-lg md:text-lg">{logo}</div>
          ))}
        </div>
      </div>
    </div>
  );
}